import { Pet, PetRehomingRequest } from './pet';

interface UserName {
  firstName: string;
  lastName: string;
}

export enum UserTelephoneType {
  Main = 1,
  Second,
}

export enum ProductType {
  Basic = 1,
  Premium,
  LegacyPremium,
  LegacyPlus,
  BasicPlus,
}

export enum AccountType {
  Undefined,
  SuperAdmin,
  CustomerAdmin,
  WarehouseAdmin,
  Keeper,
  Carer,
  Vet,
  Breeder,
  Registrar,
  ReHomer,
  CRN,
}

export interface UserTelephone {
  readonly id?: number;
  name?: string;
  number: string;
  numberType: UserTelephoneType;
}

export interface UserContact {
  email?: string;
  mainPhoneNumber: string;
  secondaryPhoneNumber: string;
  temporaryContactName?: string;
  temporaryPhoneNumber?: string;
}

export enum UserAddressType {
  Main = 1,
  HolidayHome,
  CarersHome,
  RelativesHome,
  HolidayDestination,
  CarersAddress,
  KennelOrLodgings,
  Other,
}

interface UserAddressTemporaryInfo {
  dateStart: Date;
  dateEnd: Date;
}

export interface BannerDetails {
  id: number;
  name: string,
  message: string,
  color: string,
  isEnabled: boolean
}

export interface DeclarationChecks {
  microchipWasAccurate: boolean,
  noPreExistingConditions: boolean,
}

export interface UserAddress {
  readonly id?: number;
  line1: string;
  line2: string;
  town: string;
  county: string;
  postcode: string;
  addressType: UserAddressType;
  temporary: UserAddressTemporaryInfo;
  temporaryPhoneNumber?: string;
  temporaryContactName?: string;
}

export interface UserCommunicationPreferences {
  email: boolean;
  sms: boolean;
  telephone: boolean;
  thirdPartyCommunicationEmail: boolean;
  thirdPartyCommunicationSms: boolean;
  inverseThirdPartyCommunicationEmail: boolean;
  inverseThirdPartyCommunicationSms: boolean;
}

export interface CommunicationPreferencesSettings {
  emailChecked: boolean;
  smsChecked: boolean;
  telephoneChecked: boolean;
}

export enum ThirdPartyCommunicationStepStates {
  NotAffected = 0,
  NotUpdated = 1,
  Updated = 2,
}

export enum KeeperResponseStatus {
  ConsentGivenResponse = 1,
  ConsentDeniedResponse = 2,
}

export enum MembershipSelectStepStates {
  NotAffected = 0,
  NotUpdated = 1,
  Updated = 2,
}

export enum WelcomeGiftStepState {
  NotAffected = 0,
  NotUpdated = 1,
  Updated = 2,
}

export interface User {
  readonly id: number;
  readonly token: string;
  readonly isActive: boolean;
  readonly stripeCustomerId: string;
  readonly stripePriceId: string;
  addresses: UserAddress[];
  communicationPreferences: UserCommunicationPreferences;
  contact: UserContact;
  name: UserName;
  readonly productType: ProductType;
  readonly originalProductType: ProductType;
  readonly accountType: AccountType;
  readonly roles: AccountType[];
  pets: Pet[];
  readonly detailsUpdatable: boolean;
  readonly ultimate: boolean;
  updatedAfterThirdPartyCommAdd: number;
  readonly title: string;
  readonly dateOfBirth: Date;
  readonly gender: string;
  thirdPartyCommStepCompleted: number;
  readonly membershipSelectStepCompleted: number;
  readonly welcomeGiftStepCompleted: number;
  readonly isSocialLoginUser: boolean;
  readonly hasOpenTokRequests: boolean;
  created: Date;
  tokRequests: TokRequest[];
}

export interface UserWithResponseStatus extends User {
  responseStatus: number;
}

export interface TokRequest {
  chipNumber: string;
  id: number;
  newKeeperId: number;
  oldKeeperId: number;
  createdById: number;
  status: number;
  type: number;
  pet: PetRehomingRequest;
}
